import {ko, $} from './libs.js';
import EditableViewModelState from './knockout/EditableViewModelState.js';
import './knockout/koToggleableExtender.js';

/**
 * @constructor
 **/
function ShowroomViewModel() {
    let MAIN_CONTENT_HTML_TPL_ID = 'mainContentHtmlTpl',
        VALID_RESULT_HTML_MARKER = 'data-is-ajax-response="true"',
        _hasAjaxResultInTemplate = false,
        _initHistory = function() {
            if (!document.getElementById('filterForm') || !history.replaceState) {
                return;
            }
            history.replaceState({isUrlLoadable: true}, document.title, location.href);

            $(window).on('popstate', (e) => {
                if (e.originalEvent && e.originalEvent.state && e.originalEvent.state.isUrlLoadable) {
                    setTimeout(() => _loadResults(false), 0);
                }
                return true;
            });

        };

    this.isOpeningHoursExpanded = ko.observable(false).extend({toggleable: true});
    this.isAboutUsExpanded = ko.observable(false).extend({toggleable: true});
    this.isReadMoreExpanded = ko.observable(false).extend({toggleable: true});

    this.isAboutUsExpanded.subscribe(isExpanded => {
        if (!isExpanded) {
            this.isReadMoreExpanded(false);
        }
    });

    this.isReadMoreExpanded.subscribe(this.isAboutUsExpanded);

    this.state = new EditableViewModelState({}, true);

    this.hasAjaxResultInTemplate = ko.computed(() => {
        _hasAjaxResultInTemplate = _hasAjaxResultInTemplate || this.state.isLoaded();
        return _hasAjaxResultInTemplate;
    });

    this.mainContentHtml = ko.observable();
    this.contentHtmlTemplateId = ko.observable(MAIN_CONTENT_HTML_TPL_ID);

    let _loadResults = (useFilterForm) => {
        let ajaxUrl = useFilterForm ? location.href.replace(/([?#].*|$)/, '?') + $('#filterForm').serialize() : location.href;

        if (useFilterForm) {
            history.pushState({isUrlLoadable: true}, document.title, ajaxUrl);
        }

        this.state.startLoad();

        $.ajax ({
            url: ajaxUrl,
            dataType: 'html'
        }).done (res => {
            let isValidResponse = (res && res.indexOf(VALID_RESULT_HTML_MARKER) > 0);

            if (isValidResponse) {
                this.mainContentHtml(res);
            } else {
                this.state.errors('We are sorry - an error occurred while loading the listings. Please try again.');
            }
        }).fail(err => {
            this.state.errors('We are sorry - a server occurred while loading the listings. Please try again.');
            /*eslint no-console: 0 */
            console.error('Error: ' + err.status);
        }).always(() => {
            let hasErrors = this.state.hasErrors();
            this.state.endLoad(!hasErrors);

            if (!hasErrors) {
                this.contentHtmlTemplateId.valueHasMutated();
            }
        });
    };

    this.loadResults = () => _loadResults(true);

    _initHistory();
}

ko.applyBindings(new ShowroomViewModel());
